import React, {Component} from 'react';
import {fixDecimals} from "../../../helpers/helpers";

const d3 = require("d3");

class HorizontalBars {
  constructor(data, colors, width, height, onRow, total) {
    this.data = data.map((value) => ((+fixDecimals(value, 0)) || 0));
    this.colors = [...colors];
    this.width = width;
    this.height = height;
    this.onRow = onRow;
    this.total = total;
  }

  buildBase(node) {
    this.node = node;
    const svg = d3.select(this.node);
    const marginTop = this.onRow ? 5 : 15;
    svg
      .attr('style', 'overflow: visible;')
      .attr('height', this.height + marginTop + 'px');
    this.accumulated = [];
    svg.selectAll("*").remove();
    const totalAux = this.data.reduce((sum, val) => {
      this.accumulated.push(sum);
      return sum + val;
    }, 0);
    const total = this.total || totalAux;
    svg.append('filter')
      .attr('id', 'shadow')
      .append('feGaussianBlur')
      .attr('in', 'SourceGraphic')
      .attr('stdDeviation', 2);
    this.group = svg.append('g').attr('transform', 'translate(0,0)');
    let totalWidth = 0;
    const bars = this.group.selectAll()
      .data(this.data)
      .enter()
      .append('rect')
      .attr('y', marginTop)
      .attr('x', (d, i) => (total === 0 ? 0 : (this.accumulated[i] * (this.width) / total)))
      .attr('width', (d, i, x) => {
        const width = (total === 0 ? 0 : (this.data[i] * this.width / total));
        totalWidth += width;
        return width;
      })
      .attr('height', this.height)
      .attr('fill', (d, i) => this.colors[i]);
    svg
      .attr('width', totalWidth + 'px')
      // .attr('height', '100%')
      // .attr('width', '100%')
      .attr('viewBox', `0 0 ${totalWidth} ${this.height + marginTop}`);
    const tags = this.group.selectAll()
      .data(this.data)
      .enter()
      .append('text')
      .text(d => d)
      .attr('x', (d, i) => (total === 0 ? 0 : (((this.accumulated[i] + this.data[i]) * (this.width) / total) - 4)))
      .attr('y', marginTop + (this.onRow ? 10 : 19))
      .attr('text-anchor', 'end')
      .attr('alignment-baseline', 'central')
      .attr('font-size', this.onRow ? 15 : 16)
      .attr('fill', 'white')
      .attr('style', 'font-family: \'Roboto Condensed\'; font-weight: 900');
    this.popupShadow = this.group.append('path')
      //.attr('height', 20)
      //.attr('width', 40)
      //.attr('stroke-width', 2)
      //.attr('stroke', 'white')
      //.style('opacity', 0)
      .attr('fill', 'black')
      .attr('filter', 'url(#shadow)');
    this.popup = this.group.append('path')
      //.attr('height', 20)
      //.attr('width', 40)
      //.attr('stroke-width', 2)
      //.attr('stroke', 'white')
      //.style('opacity', 0)
      .attr('fill', 'white');

    this.textPopUp = this.group
      .append('text')
      .attr('y', this.onRow ? 8 : 15)
      .attr('text-anchor', 'middle')
      .attr('alignment-baseline', 'central')
      .attr('font-size', 16)
      .attr('fill', 'black')
      .attr('style', 'font-family: \'Roboto Condensed\'; font-weight: 900')
      .style('opacity', 0);
    const barsOver = this.group.selectAll()
      .data(this.data)
      .enter()
      .append('rect')
      .attr('y', marginTop)
      .attr('x', (d, i) => (total === 0 ? 0 : (this.accumulated[i] * (this.width) / total)))
      .attr('width', (d, i, x) => (total === 0 ? 0 : (this.data[i] * this.width / total)))
      .attr('height', 38)
      .attr('opacity', 0.0);

    const size = tags.nodes().length;
    const me = this;
    for (let i = 0; i < size; ++i) {
      if (tags.nodes()[i].getComputedTextLength() + 13 > d3.select(bars.nodes()[i]).attr('width')) {
        d3.select(barsOver.nodes()[i])
          .on('mouseover', function (event, d) {
            const targetLength = tags.nodes()[i].getComputedTextLength() + 14;
            const x = (me.accumulated[i] + me.data[i] / 2) * (me.width) / total - targetLength / 2;
            //   (me.accumulated[i] + me.data[i] / 2) * (me.width-4),
            //   (me.accumulated[i] + me.data[i] / 2) );
            const fixedX = Math.max(Math.min(x, (me.width) - targetLength), 0);
            me.textPopUp.attr('x', fixedX + targetLength / 2);
            me.textPopUp.text(d);
            //me.popup.attr('x',  fixedX);
            const center = (me.accumulated[i] + me.data[i] / 2) * (me.width) / total;
            // let widthData = me.data[i] * (me.width-4) / total; //
            const t = 10;
            // let b = Math.max(Math.min(fixedX + targetLength - center - t/2, targetLength - t), 0); //
            // let delta = fixedX + targetLength - b - center;
            // let bottom = (fixedX + targetLength / 2) < center ? Math.max(0, targetLength - b - t / 2) : Math.min(0,0); //
            // let datum = 'M ' + fixedX + ' 0 h ' + targetLength + ' v 30 h -' + b + ' l -' + delta + ' ' + t/2 + ' l -' + (t - delta) + ' -' + t/2 + ' h -' + (targetLength - b - t); //
            const datum = 'M ' + fixedX + ' 0 h ' + targetLength + ' v ' + (me.onRow ? '15' : '30') + ' h -' + (targetLength - t) / 2 + ' L ' + center + ' ' + (me.onRow ? 20 : (30 + t / 2))
             + ' L ' + (fixedX + (targetLength - t) / 2) + ' ' + (me.onRow ? '15' : '30') + ' h -' + (targetLength - t) / 2;
            me.popup.attr('d', datum + ' L ' + fixedX + ' 30');
            me.popupShadow.attr('d', datum);
            //me.popup.attr('width', targetLength)
            //me.popup.attr('fill', me.colors[i])
            me.popupShadow.style('opacity', 1);
            me.popup.style('opacity', 1);
            me.textPopUp.style('opacity', 1);
          })
          .on('mouseout', function () {
            me.popup.style('opacity', 0);
            me.popupShadow.style('opacity', 0);
            me.textPopUp.style('opacity', 0);
          });
        d3.select(tags.nodes()[i]).style('opacity', 0);
      }
    }
  }
}

const react = React.createElement;

class DistanceGraph extends Component {
  constructor(props) {
    super(props);
    this.bars = new HorizontalBars(this.props.data, this.props.colors, this.props.width, this.props.height, this.props.onRow, this.props.total);
  }

  render() {
    return react('svg', {ref: node => this.node = node});
  }

  componentDidMount() {
    this.bars.buildBase(this.node);
  }

  shouldComponentUpdate(nextProps, nexState) {
    this.bars = new HorizontalBars(nextProps.data, nextProps.colors, nextProps.width, nextProps.height, nextProps.onRow, nextProps.total);
    this.bars.buildBase(this.node);
    return true;
  }
}

export default DistanceGraph;
